
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink } from 'dumi/theme';
    import API from 'dumi-theme-default/es/builtins/API.js';
import Alert from 'dumi-theme-default/es/builtins/Alert.js';
import Badge from 'dumi-theme-default/es/builtins/Badge.js';
import Example from 'dumi-theme-default/es/builtins/Example.js';
import Previewer from 'dumi-theme-default/es/builtins/Previewer.js';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode.js';
    import DUMI_ALL_DEMOS from '@@/dumi/demos';

    const DumiDemo1 = React.memo(DUMI_ALL_DEMOS['date-range-demo'].component);

    export default (props) => {
      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return (
        <>
          
          <React.Fragment><div className="markdown"><h2 id="daterange"><AnchorLink to="#daterange" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>DateRange</h2>
<p>时间选择器</p>
<h3 id="何时使用"><AnchorLink to="#何时使用" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>何时使用</h3>
<ul>
<li>需要展示时间选择器</li>
</ul>
<h3 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h3>
<p>简单使用：</p>
</div><Previewer {...DUMI_ALL_DEMOS['date-range-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h3 id="api"><AnchorLink to="#api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API</h3>
<h5 id="daterange-1"><AnchorLink to="#daterange-1" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>DateRange</h5>





















































<table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>value</td><td>选中的值</td><td>{"{"} type: string; range: [Moment | null, Moment | null] | null[] {"}"}</td><td>-</td></tr><tr><td>label</td><td>展示文案</td><td>string</td><td>-</td></tr><tr><td>preLabel</td><td>前置文案</td><td>string</td><td>-</td></tr><tr><td>timeDisable</td><td>是否显示 time 选择</td><td>boolean</td><td>false</td></tr><tr><td>hasNoYear</td><td>是否显示 year 的快捷选择项</td><td>boolean</td><td>false</td></tr><tr><td>rangeValid</td><td>可选择的时间范围</td><td>[Moment | null, Moment | null]</td><td>-</td></tr><tr><td>onChange</td><td>选中值变化时的回调</td><td>(v: {"{"} type: string; range: [Moment | null, Moment | null] | null[]; {"}"}) =&gt; void</td><td>-</td></tr></tbody></table></div></React.Fragment>
        </>
      );
  }